import { PieChart } from "lucide-react";

export function WeeklyPreview() {
  return (
    <section id="weekly-preview" className="section-wrapper weekly-preview">
      <div className="weekly-preview-container">
        <div className="left-section">
          <div className="section-tag">WEEKLY SALON CLARITY PREVIEW</div>
          <h2 className="section-heading">
            See What Weekly Salon <br /> Clarity Can Look Like
          </h2>
          <p className="section-description">
            A simple weekly view of what came in, what went out, what was left,
            and where profit may be leaking inside your salon.
          </p>

          <div className="features-pill-list">
            <div className="feature-pill">
              <span className="feature-pill-icon weekly">📊</span>
              <span>Weekly Health View</span>
            </div>
            <div className="feature-pill">
              <span className="feature-pill-icon leak">💧</span>
              <span>Leak Detection</span>
            </div>
            <div className="feature-pill">
              <span className="feature-pill-icon category">
                <PieChart size={18} style={{ display: 'inline-block', verticalAlign: 'middle', marginBottom: '2px' }} />
              </span>
              <span>Category Performance</span>
            </div>
          </div>
        </div>

        <div className="right-card">
          <div className="dashboard-panel">
            <div className="dashboard-header">
              <h3 className="dashboard-title">WEEKLY MUNAFA INTELLIGENCE DECK</h3>
              <div className="dashboard-status">
                <span className="status-dot">↗</span> Strong Week
              </div>
            </div>

            <div className="dashboard-meta">
              <span className="meta-item">
                Week: <strong>W-14</strong>
              </span>
              <span className="meta-divider" />
              <span className="meta-item">
                Date: <strong>01 Apr to 07 Apr</strong>
              </span>
              <span className="meta-divider" />
              <span className="meta-item">
                Salon: <strong>Aurora Unisex Salon</strong>
              </span>
            </div>

            <div className="data-tile-grid">
              <div className="data-tile tile-revenue">
                <span className="data-label">Total Revenue</span>
                <strong className="data-value">₹1,84,500</strong>
                <span className="tile-icon">📈</span>
              </div>
              <div className="data-tile tile-expense">
                <span className="data-label">Total Expenses</span>
                <strong className="data-value">₹1,16,800</strong>
                <span className="tile-icon">📉</span>
              </div>
              <div className="data-tile tile-net">
                <span className="data-label">Net Position</span>
                <strong className="data-value">₹67,700</strong>
                <span className="tile-icon">💰</span>
              </div>
              <div className="data-tile tile-bill">
                <span className="data-label">Avg Bill Value</span>
                <strong className="data-value">₹1,245</strong>
                <span className="tile-icon">🧾</span>
              </div>

              <div className="data-tile tile-secondary">
                <span className="data-label">vs Last Week</span>
                <strong className="data-value positive">+8.6%</strong>
                <span className="tile-icon">📊</span>
              </div>
              <div className="data-tile tile-secondary">
                <span className="data-label">Leak Alert</span>
                <strong className="data-value">Moderate</strong>
                <span className="tile-icon">⚠️</span>
              </div>
              <div className="data-tile tile-secondary">
                <span className="data-label">Top Expense</span>
                <strong className="data-value">Rent + EMI</strong>
                <span className="tile-icon">🏢</span>
              </div>
              <div className="data-tile tile-secondary">
                <span className="data-label">Product Contribution</span>
                <strong className="data-value">14%</strong>
                <span className="tile-icon">🧴</span>
              </div>
            </div>

            <div className="dashboard-split">
              <div className="performance-section">
                <h4 className="performance-title">CATEGORY PERFORMANCE</h4>
                <div className="performance-items">
                  <div className="performance-item">
                    <span className="perf-label">Beauty Services</span>
                    <div className="perf-bar">
                      <div className="perf-fill" style={{ width: "44%" }}></div>
                    </div>
                    <span className="perf-percent">44%</span>
                  </div>
                  <div className="performance-item">
                    <span className="perf-label">Hair Services</span>
                    <div className="perf-bar">
                      <div className="perf-fill" style={{ width: "34%" }}></div>
                    </div>
                    <span className="perf-percent">34%</span>
                  </div>
                  <div className="performance-item">
                    <span className="perf-label">Retail Products</span>
                    <div className="perf-bar">
                      <div className="perf-fill" style={{ width: "14%" }}></div>
                    </div>
                    <span className="perf-percent">14%</span>
                  </div>
                  <div className="performance-item">
                    <span className="perf-label">Nail Art</span>
                    <div className="perf-bar">
                      <div className="perf-fill" style={{ width: "8%" }}></div>
                    </div>
                    <span className="perf-percent">08%</span>
                  </div>
                </div>
              </div>

              <div className="signals-section">
                <h4 className="signals-title">QUICK WEEKLY SIGNALS</h4>
                <div className="signals-items">
                  <div className="signal-item">
                    <span className="signal-label">Cash Reserve</span>
                    <span className="signal-value positive">2.3 Weeks</span>
                  </div>
                  <div className="signal-item">
                    <span className="signal-label">Discount Impact</span>
                    <span className="signal-value positive">Low</span>
                  </div>
                  <div className="signal-item">
                    <span className="signal-label">Peak Day</span>
                    <span className="signal-value blue">Saturday</span>
                  </div>
                </div>
              </div>
            </div>

            <p className="dashboard-footer">
              <span className="footer-icon">💡</span>
              Simple to read. Practical to use. Built for weekly salon decisions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
